<div #top>
  <div *ngIf="!image" class="manual">
    <div class="english">
      <h1>How To Use</h1>
      <ol>
        <li>Write your <code>LaTeX</code> code in the editor above;
        <li>Click <b>"Generate"</b> button on the left;
        <li>Copy &amp; Paste the image generated in this pane; and/or
        <li>Download <code>.png</code>, <code>.eps</code>, or <code>.svg</code> by clicking bottons on the left.
      </ol>
      <h1>Tips</h1>
      <ul>
        <li><code>{{ keyModifier }}-S</code> generates an image (as <b>Generate</b> button clicked).
        <li>The editor's key binding is listed <a href="https://github.com/ajaxorg/ace/wiki/Default-Keyboard-Shortcuts">here</a>. (It is based on <a href="https://ace.c9.io/">ACE Editor</a>.) For example, {{ keyModifier }}-Z is Undo.
	<li>Use browser's Back / Forward button to access image generation history.
	<li><a target="_new" href="http://ftp.yz.yamagata-u.ac.jp/pub/CTAN/info/symbols/comprehensive/symbols-a4.pdf">The Comprehensive LaTeX Symbol List</a>
	<li><a target="_new" href="https://www.tug.org/FontCatalogue/mathfonts.html">The LaTeX Font Catalogue with math support</a>
      </ul>
      <h1>What's New</h1>
      <ul>
	<li>v0.6.0: Replaced the back-end with TeXLive2025, and fixed UI bugs.
	<li>v0.5.2: Replaced the back-end with TeXLive2021.
	<li>v0.5.1: Made additional file types .svg, .dvi, and .gif available for download.
	<li>v0.5.0: Renewed the UI and replaced the back-end with TeXLive2020.
      </ul>
    </div>
    <div class="japanese">
      <h1>使い方</h1>
      <ol>
        <li>上のエディタで <code>LaTeX</code> のコードを書く。
        <li>左の <b>"Generate"</b> ボタンを押す。
        <li>ここに表示されるイメージをコピー＆ペーストする。または、
        <li>左のボタンを押して、<code>.png</code>, <code>.eps</code>, <code>.svg</code> をダウンロードする。
      </ol>
      <h1>ヒント</h1>
      <ul>
        <li><code>{{ keyModifier }}-S</code>でイメージ生成 (<b>Generate</b>ボタンと同じ)。
        <li>エディタのキーボード設定は<a href="https://github.com/ajaxorg/ace/wiki/Default-Keyboard-Shortcuts">ここ</a>に示されている。 (<a href="https://ace.c9.io/">ACE Editor</a>を使用している。) 例えば{{ keyModifier }}-Z は取消。
	<li>ブラウザの Back / Forward ボタンを使うと以前イメージ生成記録にアクセスできる。
	<li><a target="_new" href="http://ftp.yz.yamagata-u.ac.jp/pub/CTAN/info/symbols/comprehensive/symbols-a4.pdf">LaTeXシンボルの網羅的リスト</a>
	<li><a target="_new" href="https://www.tug.org/FontCatalogue/mathfonts.html">MathサポートのあるLaTeXフォントカタログ</a>
      </ul>
      <h1>新着情報</h1>
      <ul>
	<li>v0.6.0: バックエンドをTeXLive2025に変更。UIのバグを修正。
	<li>v0.5.2: バックエンドをTeXLive2021に変更。
	<li>v0.5.1: ダウンロードできるファイルタイプに .svg, .dvi, .gif を追加。
	<li>v0.5.0: UIを刷新し、バックエンドをTeXLive2020ベースに変更。
      </ul>
    </div>
  </div>
  <div *ngIf="image" class="image">
    <img [src]="image">
  </div>
</div>
